/** Type of the account to be created. */
export enum WebSiteAccountType {
  None = "none",
  Household = "household",
  Worker = "worker",
  Company = "company"
}